/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPtTicketRequest as AgentApiContractAddPtTicketRequest } from '../../models/AgentApi/Contract/add-pt-ticket-request';
import { AddPtTicketResponse as AgentApiContractAddPtTicketResponse } from '../../models/AgentApi/Contract/add-pt-ticket-response';

export interface ApiAgentAddPtTicketPost$Plain$Params {

/**
 * * Interface language
 */
  lang?: string;
      body?: AgentApiContractAddPtTicketRequest
}

export function apiAgentAddPtTicketPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentAddPtTicketPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAddPtTicketResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentAddPtTicketPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractAddPtTicketResponse>>;
    })
  );
}

apiAgentAddPtTicketPost$Plain.PATH = '/api/Agent/AddPtTicket';
